const negotiateDates = require('./mergeEvents/negotiateDates');
const negotiateLocation = require('./mergeEvents/negotiateLocation');
const negotiateName = require('./mergeEvents/negotiateName');
const negotiateSignature = require('./mergeEvents/negotiateSignature');

module.exports = function mergeEvents(event, comparedEvent) {
    negotiateDates(event, comparedEvent);
    negotiateLocation(event, comparedEvent);
    negotiateName(event, comparedEvent);
    negotiateSignature(event, comparedEvent);
    comparedEvent.placeAction = event.placeAction;
};
